import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { getExtraDataInfoStyle } from './ExtraDataInfoStyle';
import { Avatar, isValidObject, Typography, getTestId } from '@airtel/air-design-system';
var ExtraDataInfo = props => {
  var _props$extraInfoProps = props.extraInfoProps,
    extraInfoProps = _props$extraInfoProps === void 0 ? {} : _props$extraInfoProps,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ExtraDataInfo' : _props$testID;
  var style = getExtraDataInfoStyle();
  return isValidObject(extraInfoProps) ? _jsxs(View, Object.assign({}, getTestId(testID, 'extraDataInfo'), {
    style: [style.container, extraInfoProps === null || extraInfoProps === void 0 ? void 0 : extraInfoProps.style]
  }, {
    children: [_jsx(Typography, Object.assign({}, extraInfoProps.titleProps)), _jsx(Avatar, Object.assign({}, extraInfoProps.iconProps))]
  })) : null;
};
export default ExtraDataInfo;